import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { Text } from "./Text";

/** Унифицированный чекбокс для выбора нескольких вариантов в интерфейсе. */
type CheckboxProps = Omit<ComponentPropsWithoutRef<"input">, "type" | "onChange"> & {
	label: ReactNode;
	inputClassName?: string;
	onChange: (checked: boolean) => void;
};

export const Checkbox = ({
	label,
	onChange,
	className,
	inputClassName = "",
	...props
}: CheckboxProps) => (
	<label className={`flex items-center gap-1.5 ${className ?? ""}`}>
		<input
			className={inputClassName}
			type="checkbox"
			onChange={(event) => onChange(event.target.checked)}
			{...props}
		/>
		{typeof label === "string" ? <Text as="span">{label}</Text> : label}
	</label>
);
